export const SET_DISP_TEAMS = 'SET_DISP_TEAMS'
export const UPDATE_DISP_TEAMS = 'UPDATE_DISP_TEAMS'
export const SET_DRAGGING_PLAYER = 'SET_DRAGGING_PLAYER'

export const setDispTeams = teams => {
  return { type: SET_DISP_TEAMS, teams }
}

export const updateDispTeams = () => {
  return { type: UPDATE_DISP_TEAMS }
}

export const setDraggingPlayer = draggingPlayer => {
  return { type: SET_DRAGGING_PLAYER, draggingPlayer }
}
